export default "__VITE_ASSET__DLuf_E7p__"